/* Caliber theme — vanilla JS, no dependencies */
(() => {
  'use strict';
  const T = window.theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Utilities ---------- */
  function formatMoney(cents, format = T.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = (n, d, ts = ',', ds = '.') => {
      n = (n / 100).toFixed(d);
      const [i, f] = n.split('.');
      return i.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts) + (f ? ds + f : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        default: return fmt(cents, 2);
      }
    });
  }
  T.formatMoney = formatMoney;

  function toast(msg) {
    const el = $('.toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(el._t);
    el._t = setTimeout(() => (el.hidden = true), 2600);
  }

  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  function lockScroll(on) { document.body.classList.toggle('overflow-hidden', on); }

  /* ---------- Drawers & modals ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(() => d.classList.add('is-open'));
    lockScroll(true);
    const f = d.querySelector('input, button, a');
    f && setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) {
    if (!d) return;
    d.classList.remove('is-open');
    lockScroll(false);
    if (d.matches('.search-modal, .modal')) d.hidden = true;
    lastFocus && lastFocus.focus && lastFocus.focus();
  }
  T.openDrawer = openDrawer;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'CartDrawer' && T.cartType !== 'drawer') return;
      e.preventDefault();
      openDrawer(opener.dataset.open);
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer, .modal, .search-modal'));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open, .modal:not([hidden]), .search-modal:not([hidden])').forEach(closeDrawer);
  });

  /* ---------- Cart ---------- */
  const Cart = {
    sectionsFor() {
      const ids = ['cart-drawer'];
      const main = $('[data-cart-section]');
      if (main) ids.push(main.dataset.cartSection);
      return ids;
    },
    render(sections) {
      if (!sections) return;
      Object.entries(sections).forEach(([id, html]) => {
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const target = document.getElementById('shopify-section-' + id);
        const src = doc.getElementById('shopify-section-' + id);
        if (target && src) {
          if (id === 'cart-drawer') {
            const tb = target.querySelector('[data-drawer-inner]');
            const sb = src.querySelector('[data-drawer-inner]');
            if (tb && sb) tb.innerHTML = sb.innerHTML; else target.innerHTML = src.innerHTML;
          } else target.innerHTML = src.innerHTML;
          init(target);
        }
      });
    },
    async refreshCount() {
      const c = await fetch(T.routes.root + 'cart.js').then((r) => r.json());
      $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      return c;
    },
    async add(formData, btn) {
      btn && btn.classList.add('loading');
      formData.append('sections', this.sectionsFor().join(','));
      formData.append('sections_url', window.location.pathname);
      try {
        const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
        const data = await res.json();
        if (data.status) { toast(data.description || data.message); return; }
        this.render(data.sections);
        await this.refreshCount();
        const qv = $('#QuickView');
        if (qv && !qv.hidden) closeDrawer(qv);
        if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) openDrawer('CartDrawer');
        else if (T.cartType === 'page') window.location = T.routes.cart;
        else toast(T.strings.added);
      } catch (err) { console.error(err); } finally { btn && btn.classList.remove('loading'); }
    },
    async change(line, quantity) {
      $$('[data-cart-body]').forEach((b) => (b.style.opacity = '.5'));
      const res = await fetch(T.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: this.sectionsFor(), sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (data.status) toast(data.description || data.message);
      this.render(data.sections);
      $$('[data-cart-body]').forEach((b) => (b.style.opacity = ''));
      this.refreshCount();
    }
  };
  T.Cart = Cart;

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-btn]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('.qty');
      const input = wrap.querySelector('input');
      const step = qtyBtn.dataset.qtyBtn === 'plus' ? 1 : -1;
      const min = parseInt(input.min || 0, 10);
      input.value = Math.max(min, (parseInt(input.value, 10) || 0) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); Cart.change(parseInt(rm.dataset.removeLine, 10), 0); }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) Cart.change(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10));
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  });

  // Product forms & quick add
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || T.cartType === 'page' && !form.dataset.ajax) return;
    e.preventDefault();
    Cart.add(new FormData(form), form.querySelector('[type=submit]'));
  });

  /* ---------- Quick view ---------- */
  async function openQuickView(url) {
    const modal = $('#QuickView');
    if (!modal) return (window.location = url);
    const content = modal.querySelector('[data-content]');
    content.innerHTML = '<div style="padding:8rem;text-align:center">…</div>';
    modal.hidden = false;
    lockScroll(true);
    const u = new URL(url, window.location.origin);
    u.searchParams.set('view', 'quick-view');
    const html = await fetch(u).then((r) => r.text());
    content.innerHTML = html;
    init(content);
  }
  document.addEventListener('click', (e) => {
    const qv = e.target.closest('[data-quick-view]');
    if (qv) { e.preventDefault(); openQuickView(qv.dataset.quickView); }
  });

  /* ---------- Product: variants ---------- */
  function initProduct(root) {
    $$('[data-product]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const dataEl = el.querySelector('[data-product-json]');
      if (!dataEl) return;
      const data = JSON.parse(dataEl.textContent);
      const form = el.querySelector('form[data-product-form]');
      const idInput = form && form.querySelector('[name=id]');
      const update = () => {
        const selected = $$('[data-option-index]', el).map((grp) => {
          const c = grp.querySelector('input:checked') || grp.querySelector('select');
          return c ? c.value : null;
        });
        const variant = data.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        // availability styling
        $$('[data-option-index]', el).forEach((grp) => {
          const idx = parseInt(grp.dataset.optionIndex, 10);
          $$('input', grp).forEach((inp) => {
            const test = selected.slice(); test[idx] = inp.value;
            const ok = data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
            inp.classList.toggle('is-unavailable', !ok);
          });
          const label = grp.querySelector('[data-selected-value]');
          if (label) label.textContent = selected[idx];
        });
        const buttons = $$('[data-add-button]', el.closest('.shopify-section') || el);
        if (!variant) {
          buttons.forEach((b) => { b.disabled = true; b.querySelector('span').textContent = T.strings.unavailable; });
          return;
        }
        if (idInput) idInput.value = variant.id;
        $$('[data-variant-id-input]', el.closest('.shopify-section') || el).forEach((i) => (i.value = variant.id));
        buttons.forEach((b) => {
          b.disabled = !variant.available;
          b.querySelector('span').textContent = variant.available ? (b.dataset.label || T.strings.addToCart) : T.strings.soldOut;
        });
        $$('[data-price]', el.closest('.shopify-section') || el).forEach((p) => {
          const sale = variant.compare_at_price > variant.price;
          p.classList.toggle('price--sale', sale);
          p.innerHTML = `<span class="price__current">${formatMoney(variant.price)}</span>` + (sale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s>` : '');
        });
        const inv = el.querySelector('[data-inventory]');
        if (inv) {
          const q = variant.inventory_quantity, thr = parseInt(inv.dataset.threshold || 5, 10);
          inv.hidden = false;
          inv.className = 'product__inventory';
          if (!variant.available) { inv.classList.add('product__inventory--out'); inv.textContent = inv.dataset.out; }
          else if (variant.tracked && q > 0 && q <= thr) { inv.classList.add('product__inventory--low'); inv.textContent = inv.dataset.low.replace('[count]', q); }
          else inv.textContent = inv.dataset.in;
        }
        const sku = el.querySelector('[data-sku]');
        if (sku) sku.textContent = variant.sku || '';
        if (variant.media_id) {
          const gallery = $('[data-gallery]', el.closest('.shopify-section') || el) || $('[data-gallery]', el);
          const item = gallery && gallery.querySelector(`[data-media-id="${variant.media_id}"]`);
          if (item) {
            const list = item.parentElement;
            if (getComputedStyle(list).overflowX === 'auto') list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
            else if (el.dataset.moveMedia !== 'false') list.prepend(item);
            $$('[data-thumb]', gallery).forEach((t) => t.setAttribute('aria-current', t.dataset.thumb == variant.media_id));
          }
        }
        if (el.dataset.updateUrl === 'true') {
          const u = new URL(window.location.href); u.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', u.toString());
        }
      };
      el.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) update(); });
      update();
    });

    // gallery thumbnails
    $$('[data-thumb]', root).forEach((t) => {
      t.addEventListener('click', () => {
        const gallery = t.closest('[data-gallery]');
        const item = gallery.querySelector(`[data-media-id="${t.dataset.thumb}"]`);
        const list = item.parentElement;
        list.scrollTo({ left: item.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        $$('[data-thumb]', gallery).forEach((x) => x.setAttribute('aria-current', x === t));
      });
    });

    // Sticky add to cart
    $$('[data-sticky-atc]', root).forEach((bar) => {
      const target = document.getElementById(bar.dataset.stickyAtc);
      if (!target) return;
      new IntersectionObserver(([en]) => {
        bar.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      }).observe(target);
      const btn = bar.querySelector('[data-sticky-submit]');
      btn && btn.addEventListener('click', () => {
        const f = document.getElementById(btn.dataset.stickySubmit);
        f && f.requestSubmit();
      });
    });

    // Product recommendations
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el._loaded) return; el._loaded = true;
      const html = await fetch(el.dataset.recommendations).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('[data-recommendations]');
      if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; init(el); }
      else if (el.dataset.hideEmpty) el.closest('.shopify-section').hidden = true;
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch(root) {
    $$('[data-predictive-search]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      const input = form.querySelector('input[name=q]');
      const results = document.getElementById(form.dataset.predictiveSearch);
      const run = debounce(async () => {
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=8&section_id=predictive-search`;
        const html = await fetch(url).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const res = doc.querySelector('#shopify-section-predictive-search');
        results.innerHTML = res ? res.innerHTML : '';
      }, 250);
      input.addEventListener('input', run);
    });
  }

  /* ---------- Sliders, slideshow ---------- */
  function initSliders(root) {
    $$('[data-slider-prev], [data-slider-next]', root).forEach((btn) => {
      if (btn._init) return; btn._init = true;
      btn.addEventListener('click', () => {
        const track = document.getElementById(btn.dataset.sliderPrev || btn.dataset.sliderNext);
        if (!track) return;
        const dir = btn.hasAttribute('data-slider-next') ? 1 : -1;
        const first = track.firstElementChild;
        const w = first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        if (dir === 1 && atEnd && track.dataset.loop) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: dir * w, behavior: 'smooth' });
      });
    });
    $$('[data-slideshow]', root).forEach((ss) => {
      if (ss._init) return; ss._init = true;
      const track = ss.querySelector('.slideshow__track');
      const dots = $$('.slideshow__dot', ss);
      const go = (i) => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      const cur = () => Math.round(track.scrollLeft / track.clientWidth);
      track.addEventListener('scroll', debounce(() => dots.forEach((d, i) => d.setAttribute('aria-current', i === cur())), 60));
      const speed = parseInt(ss.dataset.autoplay || 0, 10);
      if (speed && !(window.Shopify && Shopify.designMode)) {
        let paused = false;
        ss.addEventListener('mouseenter', () => (paused = true));
        ss.addEventListener('mouseleave', () => (paused = false));
        setInterval(() => { if (!paused) go((cur() + 1) % dots.length); }, speed * 1000);
      }
    });
    $$('[data-announcement]', root).forEach((bar) => {
      if (bar._init) return; bar._init = true;
      const slides = $$('.announcement__slide', bar);
      if (slides.length < 2) return;
      let i = 0;
      const show = (n) => { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); };
      bar.querySelectorAll('[data-ann]').forEach((b) => b.addEventListener('click', () => show(i + (b.dataset.ann === 'next' ? 1 : -1))));
      setInterval(() => show(i + 1), (parseInt(bar.dataset.speed, 10) || 5) * 1000);
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(root) {
    $$('[data-countdown]', root).forEach((el) => {
      if (el._init) return; el._init = true;
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) return;
      const units = { d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'), m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]') };
      const tick = () => {
        let diff = Math.max(0, end - Date.now());
        if (diff === 0) {
          clearInterval(t);
          if (el.dataset.expire === 'hide') { const s = el.closest('.shopify-section'); if (s && !window.Shopify?.designMode) s.hidden = true; }
          else if (el.dataset.expired) el.innerHTML = `<p class="countdown-expired">${el.dataset.expired}</p>`;
        }
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        const pad = (n) => String(n).padStart(2, '0');
        units.d && (units.d.textContent = pad(d)); units.h && (units.h.textContent = pad(h));
        units.m && (units.m.textContent = pad(m)); units.s && (units.s.textContent = pad(s));
      };
      const t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Before / after, hotspots, video ---------- */
  function initInteractive(root) {
    $$('[data-compare]', root).forEach((c) => {
      const input = c.querySelector('input');
      const set = () => c.style.setProperty('--pos', input.value + '%');
      input.addEventListener('input', set); set();
    });
    $$('[data-hotspot]', root).forEach((btn) => {
      if (btn._init) return; btn._init = true;
      btn.addEventListener('click', () => {
        const open = btn.getAttribute('aria-expanded') === 'true';
        const scope = btn.closest('.lookbook') || document;
        $$('[data-hotspot]', scope).forEach((b) => { b.setAttribute('aria-expanded', 'false'); const c = document.getElementById(b.getAttribute('aria-controls')); c && (c.hidden = true); });
        $$('.lookbook__item', scope).forEach((i) => i.classList.remove('is-active'));
        if (!open) {
          btn.setAttribute('aria-expanded', 'true');
          const card = document.getElementById(btn.getAttribute('aria-controls')); card && (card.hidden = false);
          const li = scope.querySelector(`[data-hotspot-item="${btn.dataset.hotspot}"]`); li && li.classList.add('is-active');
        }
      });
    });
    $$('[data-video-play]', root).forEach((btn) => {
      if (btn._init) return; btn._init = true;
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.video-wrap');
        const tpl = wrap.querySelector('template');
        if (tpl) { wrap.appendChild(tpl.content.cloneNode(true)); }
        const v = wrap.querySelector('video'); v && v.play();
        btn.remove();
        const poster = wrap.querySelector('.video-wrap__poster'); poster && poster.remove();
      });
    });
    // Facets: auto-submit
    $$('[data-facets-form]', root).forEach((form) => {
      if (form._init) return; form._init = true;
      form.addEventListener('change', debounce((e) => { if (e.target.type !== 'number') form.requestSubmit ? form.requestSubmit() : form.submit(); }, 200));
    });
    $$('[data-sort-select]', root).forEach((sel) => {
      sel.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', sel.value); window.location = u; });
    });
    // Localization selectors
    $$('[data-localization] select', root).forEach((s) => s.addEventListener('change', () => s.form.submit()));
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const wrap = $('.header-wrapper');
    if (!wrap) return;
    const onScroll = () => wrap.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Reveal ---------- */
  let revealObserver;
  function initReveal(root) {
    if (!document.body.classList.contains('animate-on')) return;
    if (!('IntersectionObserver' in window)) { $$('.reveal', root).forEach((e) => e.classList.add('is-visible')); return; }
    revealObserver = revealObserver || new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-visible'); revealObserver.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -60px 0px' });
    $$('.reveal:not(.is-visible)', root).forEach((e) => revealObserver.observe(e));
  }

  function init(root = document) {
    initProduct(root); initSearch(root); initSliders(root);
    initCountdown(root); initInteractive(root); initReveal(root);
  }
  T.init = init;

  document.addEventListener('DOMContentLoaded', () => {
    if (window.Shopify && Shopify.designMode) document.documentElement.classList.add('shopify-design-mode');
    initHeader(); init();
  });
  document.addEventListener('shopify:section:load', (e) => { init(e.target); initHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('.slideshow__slide');
    if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    const ann = e.target.closest('.announcement__slide');
    if (ann) { $$('.announcement__slide', ann.parentElement).forEach((s) => s.classList.remove('is-active')); ann.classList.add('is-active'); }
  });
})();
